export const presetType = {
  Battle: 'battle'
}

export const presetStatus = {
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
}

